export default "__VITE_ASSET__Di1gy92P__"